import { useState, useEffect, useRef } from 'react';
import { useRouteLoaderData, useLocation } from 'react-router-dom';
import type { PortalNavItem } from '@/types';
import { Welcome, QuickLinksSection, ProgramAnnouncementsSection, DMESection } from '@/components/home';
import styles from './HomePage.module.css';

const PANEL_TAB_CODES = new Set(['DMEProviderLocator']);
const PHARMACY_LOCATOR_TAB_ID = 'PharmacyLocator';

export function HomePage() {
  const data = useRouteLoaderData('root') as PortalNavItem | undefined;
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string | null>(null);
  const dmeRef = useRef<HTMLDivElement>(null);

   useEffect(() => {
    setActiveTab(null);
  }, [location.key]);

  
  useEffect(() => {
    setActiveTab(null);
  }, [location.key]);

  useEffect(() => {
    if (activeTab === 'DMEProviderLocator' && dmeRef.current) {
      dmeRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [activeTab]);

  if (!data) {
    return <div>Loading...</div>;
  }

  function handleTabChange(tabId: string) {
    const link = data!.quickLinks.find((q) => q.tabId === tabId);
    if (tabId === PHARMACY_LOCATOR_TAB_ID && link?.url) {
      window.open('/pharmacylocator', '_blank', 'noopener,noreferrer');
      return;
    }
    if (link?.url && !PANEL_TAB_CODES.has(tabId)) {
      window.open(link.url, '_blank', 'noopener,noreferrer');
      return;
    }
    setActiveTab((prev) => (prev === tabId ? null : tabId));
  }

  return (
    <div className={styles.page}>
      <Welcome
        welcomeHeading={data.welcomeHeading}
        welcomeNote={data.welcomeNote}
        welcomePbaHeading={data.welcomePbaHeading}
        welcomeHelpContact={data.welcomeHelpContact}
      />
      <QuickLinksSection
        quickLinks={data.quickLinks}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
      <ProgramAnnouncementsSection
        heading={data.announcementsHeading}
        announcements={data.announcements}
      />
      {activeTab === 'DMEProviderLocator' && (
        <div ref={dmeRef}>
          <DMESection
            heading={data.ancillaryHeading}
            ancillaryNote={data.ancillaryNote}
            ancillaryPhone={data.ancillaryPhone}
          />
        </div>
      )}
    </div>
  );
}

